import React from 'react';
import PropTypes from 'prop-types';
import { Appointments } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from '@material-ui/core';
import { getAppointmentColor } from '../../theme/colors';

const useStyles = makeStyles({
    appointment: props => ({
        backgroundColor: getAppointmentColor(props),
        '&:hover': {
            backgroundColor: getAppointmentColor(props, true)
        }
    })
});

const AppointmentComponent = (props) => {
    const { data } = props;
    const { appointment } = useStyles(data);
	return <Appointments.Appointment {...props} className={appointment} />
};

AppointmentComponent.propTypes = {
    data: PropTypes.object.isRequired
}

export default AppointmentComponent;
